export enum ActionType {
    COACHING_DETAIL__TD__RELOAD = 'COACHING_DETAIL__TD__RELOAD',
    COACHING_DETAIL__TD__RELOAD_RESULT = 'COACHING_DETAIL__TD__RELOAD_RESULT',
    COACHING_DETAIL__TD__SET_NOTE_VIA_SUMMARY = 'COACHING_DETAIL__TD__SET_NOTE_VIA_SUMMARY',
    COACHING_DETAIL__TD__SWITCH_VIEW = 'COACHING_DETAIL__TD__SWITCH_VIEW',
    COACHING_DETAIL__TD__FILTER_QUOTES = 'COACHING_DETAIL__TD__FILTER_QUOTES',
    COACHING_DETAIL__TD__SELECT_QUOTES = 'COACHING_DETAIL__TD__SELECT_QUOTES',
    COACHING_DETAIL__TD__UPDATE_TRANSCRIPT = 'COACHING_DETAIL__TD__UPDATE_TRANSCRIPT',
    COACHING_DETAIL__TD__UPDATE_TRANSCRIPT_RESULT = 'COACHING_DETAIL__TD__UPDATE_TRANSCRIPT_RESULT',
    COACHING_DETAIL__TD__RESET = 'COACHING_DETAIL__TD__RESET',
    COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES = 'COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES',
    COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES_RESULT = 'COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES_RESULT',
    COACHING_DETAIL__TD__EDIT_NOTES_FOCUS = 'COACHING_DETAIL__TD__EDIT_NOTES_FOCUS',
    COACHING_DETAIL__TD__ADD_COMMITMENT_NOTES = 'COACHING_DETAIL__TD__ADD_COMMITMENT_NOTES',
    COACHING_DETAIL__TD__ADD_COMMITMENT_NOTES_RESULT = 'COACHING_DETAIL__TD__ADD_COMMITMENT_NOTES_RESULT',
    COACHING_DETAIL__TD__RESET_NAV = 'COACHING_DETAIL__TD__RESET_NAV',
}
